import { Typography } from "antd";
import React from "react";

const Description = ({ product }) => {
  return (
    <>
      <Typography.Title
        level={3}
        className="description-title"
        style={{ marginBottom: "16px", textAlign: "center" }}
      >
        Description
      </Typography.Title>
      <Typography.Paragraph
        className="product-description-text"
        style={{ marginBottom: "24px" }}
      >
        {product?.description || "No description available."}
      </Typography.Paragraph>
    </>
  );
};

export default Description;
